import React, { useContext, useEffect } from "react";
import { Case, If } from "~/common/components/If";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import { API_STATE } from "~/common/constants/state";
import useRequest from "~/common/hooks/useRequest";
import { AppManContext } from "../../RoundManContext";
import ProFiveNotice from "./steps/ProFiveNotice";
import ProFourExternal from "./steps/ProFourExternal";
import ProOneSetting from "./steps/ProOneSetting";
import ProSixFinalCheck from "./steps/ProSixFinalCheck";
import ProThreeJudge from "./steps/ProThreeJudge";
import ProTwoDate from "./steps/ProTwoDate";
import { useTranslation } from "react-i18next";

const ModalAdditionEval = () => {
	const { t } = useTranslation();
	const roundResultRequest = useRequest("get", "/vc/round/review/result");
	const { addJudgeModal, setAddJudgeModal, addEvalTarget, setRoundData, addProSteps, roundData } =
		useContext(AppManContext);

	useEffect(() => {
		if (addEvalTarget) {
			roundResultRequest.call(addEvalTarget, "path");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [addEvalTarget]);

	useEffect(() => {
		switch (roundResultRequest.state) {
			case API_STATE.done:
				setRoundData(roundResultRequest.response.data);
				break;
			case API_STATE.error:
				alert(t("pages.round.RoundManage.modal.additionalRound.ModalAdditionEval.alert"));
				break;
			default:
				break;
		}
	}, [roundResultRequest.state, roundResultRequest.response, roundResultRequest.error]);

	const round = roundData?.round;

	return (
		<>
			<ModalTemplate
				modalState={addJudgeModal}
				setModalToggle={setAddJudgeModal}
				title={
					<>
						{t(
							"pages.round.RoundManage.modal.additionalRound.ModalAdditionEval.modalTitle"
						)}
						<h3>{round?.title}</h3>
					</>
				}
				width={1100}
				className="evaluate-setup-modal"
			>
				<If condition={addProSteps}>
					<Case condition={0}>
						<ProOneSetting />
					</Case>
					<Case condition={1}>
						<ProTwoDate />
					</Case>
					<Case condition={2}>
						<ProThreeJudge />
					</Case>
					<Case condition={3}>
						<ProFourExternal />
					</Case>
					<Case condition={4}>
						<ProFiveNotice />
					</Case>
					<Case condition={5}>
						<ProSixFinalCheck />
					</Case>
				</If>
			</ModalTemplate>
			{/*.addCompany Alert 모달*/}
		</>
	);
};

export default ModalAdditionEval;
